<template>
  <div class="floating-container" ref="containerVideo" :id="`floating-container-${uuid}`">
    <div class="header-floating-container" @mousedown="dragMouseDown">
      <span @click.stop="handleClose" class="closeButton">
        <feather-icon icon="XIcon" size="14" class="x-icon" />
      </span>
    </div>
    <div :class="['cam-container-floating', `cam-${cameraId}`]">
      <div v-if="uuid" :class="`camera-${uuid} video-container`"></div>
    </div>
  </div>
</template>

<script>
import CamerasSdk from "@omnicloud/cameras-sdk-v2";
import { EventBus } from "@/libs/event-bus";

export default {
  props: {
    cameraId: {
      type: [Number, String],
      required: true,
    },
    cameraProxyId: {
      type: [Number, String],
      required: true,
    },
    uuid: {
      type: String,
      required: true,
    },
    dateRange: {
      type: Object,
      default: () => ({}),
    },
    host: {
      type: String,
      default: window.__env.VUE_APP_BASE_URL,
    },
  },
  data() {
    return {
      camerasSdk: null,
      pos3: 0,
      pos4: 0,
      parent: null,
    };
  },
  mounted() {
    EventBus.on(`setLang`, this.onSetLang);
    this.parent = this.$refs.containerVideo.parentElement;
    try {
      if (document.fullscreen) {
        document.fullscreenElement.appendChild(this.$refs.containerVideo);
      }
      this.$nextTick(this.setInitialPosition);
      if (this.cameraId && this.cameraProxyId && this.uuid) {
        this.camerasSdk = new CamerasSdk(this.getCameraConfig());
      }
    } catch (e) {
      console.error("Error initializing camera SDK:", e);
    }

  },
  beforeDestroy() {
    EventBus.off(`setLang`, this.onSetLang);
    this.destroyPlayer();
  },
  methods: {
    onSetLang(lang) {
      this.camerasSdk?.setLang(lang);
    },
    setInitialPosition() {
      const container = this.$refs.containerVideo;
      if (!container) return;

      // The player is teleported to body, so viewport coordinates keep it centered.
      container.style.top = "50%";
      container.style.left = "50%";
      container.style.transform = "translate(-50%, -50%)";
    },
    getCameraConfig() {
      return {
        id: this.uuid,
        cameraId: this.cameraProxyId,
        container: `.camera-${this.uuid}`,
        token: localStorage.getItem("accessToken"),
        apiUrl: `${this.host}/v1`,
        startDate: this.dateRange?.startDate || null,
        endDate: this.dateRange?.endDate || null,
        pusher_app_key: window.__env?.VUE_APP_LARAVEL_PUSHER_APP_KEY,
        pusher_host: window.__env?.VUE_APP_LARAVEL_PUSHER_HOST,
        pusher_port: window.__env?.VUE_APP_LARAVEL_PUSHER_PORT,
        pusher_app_cluster: window.__env.VUE_APP_LARAVEL_PUSHER_APP_CLUSTER || "mt1",
        mode:
          this.dateRange?.startDate && this.dateRange?.endDate
            ? "recorded_video"
            : "live_video",
        lang: this.$i18n.locale,
      };
    },
    handleClose() {
      this.destroyPlayer();
      this.$emit("destroy", this.cameraId);
    },
    destroyPlayer() {
      if (!this.camerasSdk) return;

      // Destroy the SDK wrapper so it also exits fullscreen and releases the player.
      this.camerasSdk.destroy();
      this.camerasSdk = null;
    },
    dragMouseDown(e) {
      e.preventDefault();
      this.fixCurrentPosition();
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      document.onmouseup = this.closeDragElement;
      document.onmousemove = this.elementDrag;
    },
    fixCurrentPosition() {
      const container = this.$refs.containerVideo;
      if (!container || !container.style.transform) return;

      const rect = container.getBoundingClientRect();
      const parentRect = container.offsetParent?.getBoundingClientRect() || {
        top: 0,
        left: 0,
      };

      container.style.top = `${Math.max(0, rect.top - parentRect.top)}px`;
      container.style.left = `${Math.max(0, rect.left - parentRect.left)}px`;
      container.style.transform = "";
    },
    elementDrag(e) {
      e.preventDefault();

      const pos1 = this.pos3 - e.clientX;
      const pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;

      const container = this.$refs.containerVideo;
      container.style.top = `${Math.max(
        0,
        Math.min(
          window.innerHeight - container.offsetHeight - 10,
          container.offsetTop - pos2
        )
      )}px`;
      container.style.left = `${Math.max(
        0,
        Math.min(
          window.innerWidth - container.offsetWidth - 10,
          container.offsetLeft - pos1
        )
      )}px`;
    },
    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },
    onSetLang(lang) {
      this.camerasSdk?.setLang(lang);
    },
  },
};
</script>

<style lang="scss" scoped>
.floating-container {
  position: fixed;
  min-height: 10rem;
  min-width: 15rem;
  width: 40vw;
  height: 25vw;
  top: 0;
  left: 0;
  background: black;
  z-index: 15;
  resize: both;
  overflow: hidden;

  span {
    cursor: pointer;
    margin-right: 0.1rem;
  }

  div[class^="camera-"] {
    height: 100%;
  }

  .cam-container-floating {
    width: 100%;
    height: 100%;
    position: absolute;
  }
}

.header-floating-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2rem;
  z-index: 15;
  display: flex;
  justify-content: flex-end;
}

.closeButton {
  z-index: 16;
}
.x-icon {
  color: rgb(154, 154, 154);
  cursor: pointer;
  &:hover {
    color: white;
  }
}
</style>
